var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    fill: "#0073E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    stroke: "#0073E6",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.9565C4 9.52428 4.35039 9.17389 4.78261 9.17389L14.2174 9.17389C14.6496 9.17389 15 9.52428 15 9.9565C15 10.3887 14.6496 10.7391 14.2174 10.7391L4.78261 10.7391C4.35039 10.7391 4 10.3887 4 9.9565Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49009 5.2292C9.79571 4.92358 10.2912 4.92358 10.5969 5.2292L14.7708 9.40312C15.0764 9.70874 15.0764 10.2043 14.7708 10.5099C14.4651 10.8155 13.9696 10.8155 13.664 10.5099L9.49009 6.33598C9.18446 6.03035 9.18446 5.53483 9.49009 5.2292Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49009 14.6838C9.18446 14.3782 9.18446 13.8827 9.49009 13.577L13.664 9.40312C13.9696 9.09749 14.4651 9.09749 14.7708 9.40312C15.0764 9.70874 15.0764 10.2043 14.7708 10.5099L10.5969 14.6838C10.2912 14.9894 9.79571 14.9894 9.49009 14.6838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.4e240f5e544d3a33d3f722be9d34e3e8.svg";
export { ForwardRef as ReactComponent };